module.exports = __webpack_public_path__ + "5b3ace604b84ddc47332750650a13df4.MP3";